import * as z from "zod";

/** Matches what a rich text signature with a few inline images comes to. */
const MAX_SIGNATURE_HTML_LENGTH = 100_000;

export const setAiEmailSignature = {
  name: "setAiEmailSignature" as const,
  input: z.object({
    /** `null` removes the signature. */
    html: z.string().max(MAX_SIGNATURE_HTML_LENGTH).nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
